import moment from 'moment'

const EVENT_TYPES = {
	HEARTBEAT: 'heartbeat',
	PENDING: 'pending',
}

class Heartbeat {
	conn = null
	last_heartbeat = null
	interval = null

	constructor() {
		const SCHEMA =
			process.env.VUE_APP_HEARTBEAT_APP_ENCRYPTED === 'true'
				? 'wss'
				: 'ws'
		const HOST = process.env.VUE_APP_HEARTBEAT_APP_HOST
		const PORT = process.env.VUE_APP_HEARTBEAT_APP_PORT
		const TOKEN = window.Session.token

		this.conn = new WebSocket(
			`${SCHEMA}://${HOST}:${PORT}?JWT_TOKEN=${TOKEN}`
		)
		this.last_heartbeat = moment()

		this.conn.onopen = e => {
			this.Init()
		}
	}

	Init() {
		console.log('Iniciou o Heartbeat')

		this.StartSendingHeartbeat()
	}

	StartSendingHeartbeat() {
		if (this.interval) return

		this.SendHeartbeatEvent()

		this.interval = setInterval(() => {
			this.SendHeartbeatEvent()
		}, 60000)
	}

	SendHeartbeatEvent() {
		if (this.conn.readyState !== WebSocket.OPEN) return

		const data = {
			event: EVENT_TYPES.HEARTBEAT,
			session_key: window.Session.session_key,
		}

		this.conn.send(JSON.stringify(data))

		this.last_heartbeat = moment()
	}

	async CloseConnection() {
		return new Promise(res => {
			if (this.interval) {
				clearInterval(this.interval)
				this.interval = null
			}

			if (this.conn && this.conn.readyState !== WebSocket.CLOSED) {
				this.conn.close()
				this.conn = null
			}

			res()
			console.log('Encerrou o Heartbeat')
		})
	}
}

export default Heartbeat
